import React, { useContext, useEffect, useState } from "react";
import { useFieldArray, useFormContext } from "react-hook-form";
import { updateFormData } from "../../../stateManager/actions/BiographyActions";
import { BiographyStore } from "../../../stateManager/stores/BiographyStore";
import { ArrayFieldAddButton } from "./ArrayFieldAddButton";
import { ArrayFieldDeleteButton } from "./ArrayFieldDeleteButton";
import { ArrayFieldMoveUpDownButtons } from "./ArrayFieldMoveUpDownButtons";
import { ArrayFieldUndoButton } from "./ArrayFieldUndoButton";
import NoDataProvidedMessage from "./NoDataProvidedMessage";

function RelatedOrganisationsArray({ classNames }) {
  const {
    control,
    register,
    getValues,
    reset,
    formState: { errors },
  } = useFormContext();

  const { fields, append, remove, swap } = useFieldArray({
    control,
    name: "related_organisations",
  });

  const [displayUndoButton, setDisplayUndoButton] = useState(false);
  const { state, dispatch } = useContext(BiographyStore);
  const relatedOrganisationsValues = getValues("related_organisations");

  useEffect(() => {
    if (JSON.stringify(relatedOrganisationsValues) === JSON.stringify(state.formData.related_organisations)) {
      setDisplayUndoButton(false);
    } else {
      setDisplayUndoButton(true);
    }
  }, [relatedOrganisationsValues, state]);

  if (state?.formData.related_organisations.length === 0 && state?.isReadOnly) {
    return <NoDataProvidedMessage classNames={classNames} />;
  }

  return (
    <div className={"col-12 " + classNames}>
      {fields.map((item, index) => {
        const itemNum = index + 1;

        return (
          <div className="row g-2 field-array-row" key={item.id}>
            <div className="col-md-9 field-column">
              <div className="sub-field-array-style row g-2 mb-3" id={item.id}>
                <p className="subTitle">{`Related organisation ` + itemNum}</p>
                <div className="col-6" id={`related_organisations[${index}].name-div`}>
                  <input
                    id={`related_organisations[${index}].name`}
                    name={`related_organisations[${index}].name`}
                    {...register(`related_organisations[${index}].name`)}
                    placeholder="Name*"
                    className="form-control"
                    readOnly={state.isReadOnly}
                  />
                  {errors?.related_organisations?.[index]?.name && (
                    <span className="text-danger" data-testid="error-message">
                      {errors?.related_organisations[index].name.message}
                    </span>
                  )}
                </div>
                <div className="col-6" id={`related_organisations[${index}].affiliation-div`}>
                  <input
                    id={`related_organisations[${index}].affiliation`}
                    name={`related_organisations[${index}].affiliation`}
                    {...register(`related_organisations[${index}].affiliation`)}
                    placeholder="Affiliation"
                    className="form-control"
                    readOnly={state.isReadOnly}
                  />
                </div>
                <div className="col-12" id={`related_organisations[${index}].description-div`}>
                  <input
                    id={`related_organisations[${index}].description`}
                    name={`related_organisations[${index}].description`}
                    {...register(`related_organisations[${index}].description`)}
                    placeholder="Description"
                    className="form-control"
                    readOnly={state.isReadOnly}
                  />
                </div>
              </div>
            </div>
            {!state?.isReadOnly && (
              <div className="col-md-3">
                <div className="row flex-row p-0">
                  <ArrayFieldDeleteButton
                    dataTestId={`related-organisation-delete-button-${index}`}
                    onClick={() => {
                      updateFormData(getValues(), dispatch);
                      remove(index);
                    }}
                  />
                  <ArrayFieldMoveUpDownButtons
                    onDownButtonClick={() => swap(index, index + 1)}
                    onUpButtonClick={() => swap(index, index - 1)}
                    index={index}
                    fields={fields}
                    upButtonDataTestId={`related-organisation-${index}-up`}
                    downButtonDataTestId={`related-organisation-${index}-down`}
                  />
                </div>
              </div>
            )}
          </div>
        );
      })}

      {!state?.isReadOnly && (
        <ArrayFieldAddButton
          dataTestId={"related-organisation-add-button"}
          onClick={() => {
            append({ name: "", affiliation: "", description: "" });
            updateFormData(getValues(), dispatch);
          }}
        />
      )}
      {displayUndoButton && (
        <ArrayFieldUndoButton
          dataTestId={"related-organisation-undo-button"}
          getValues={getValues}
          append={append}
          reset={reset}
        />
      )}
    </div>
  );
}

export default RelatedOrganisationsArray;
